var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cpage-meta\u003EStart investing now\u003C\u002Fpage-meta\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-card layout-padding\u003E\u003Cp ng-if=\"vm.numberOfSteps === 1\"\u003EBefore you can go on to invest, there is just one more step:\u003C\u002Fp\u003E\u003Cp ng-if=\"vm.numberOfSteps &gt; 1\"\u003EBefore you can go on to invest, there are a few remaining steps:\u003C\u002Fp\u003E\u003Col\u003E\u003Cli class=\"identity\" ng-if=\"!vm.identityCheckVerified()\" flex layout-margin\u003E\u003Ch3\u003E\u003Cspan\u003EVerify identity\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Cdiv class=\"identity-how-to-verify\"\u003EIn order to process your application, \u003Ctenant-inline\u003Eelement-id=\"name.short\")\u003C\u002Ftenant-inline\u003E will contact you and may ask for additional documentation.\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"approval-status\" ng-if=\"!vm.investorApprovalStatusAccepted()\" ng-class=\"{ reject: vm.investorApprovalStatusRejected() }\" flex layout-margin\u003E\u003Ch3\u003E\u003Cspan\u003E\u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E approval \u003C\u002Fspan\u003E\u003Cmd-icon class=\"cross\" ng-if=\"vm.investorApprovalStatusRejected()\"\u003Eclose\u003C\u002Fmd-icon\u003E\u003C\u002Fh3\u003E\u003Cdiv class=\"approval-status-pending\" ng-if=\"vm.investorApprovalStatusPending()\"\u003E\u003Cp\u003E\u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E will review your application.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"approval-status-rejected\" ng-if=\"vm.investorApprovalStatusRejected()\"\u003E\u003Cp\u003EYour application has been declined.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"funds\" flex layout-margin\u003E\u003Ch3\u003E\u003Cspan\u003ETransfer funds\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Cdiv class=\"funds-preconditions-not-met\" ng-if=\"!vm.identityCheckVerified() || !vm.investorApprovalStatusAccepted()\"\u003E\u003Cspan\u003EBefore you can transfer money into the \u003Ctenant-inline element-id=\"name.trust\"\u003E\u003C\u002Ftenant-inline\u003E account you will need to complete the previous steps.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"funds-how-to-transfer\" ng-if=\"vm.identityCheckVerified() &amp;&amp; vm.investorApprovalStatusAccepted() &amp;&amp; !vm.fundsTransferred()\"\u003E\u003Cp\u003EPlease consider the product disclosure statement carefully and if you decide to invest, transfer\nfunds using your specific investor BPAY account details below.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cbpay-details ng-if=\"vm.investor.bpay\" biller-code=\"vm.investor.bpay.billerCode\" crn=\"vm.investor.bpay.crn\"\u003E\u003C\u002Fbpay-details\u003E\u003Cbr\u003E\u003Cp\u003E\u003Cspan\u003EIf you prefer a different payment method please call \u003C\u002Fspan\u003E\u003Ctenant-anchor anchor-id=\"contact.telephone.main\"\u003E\u003C\u002Ftenant-anchor\u003E\u003C\u002Fp\u003E\u003Cbr\u003E\u003Chelp-box\u003E\u003Ch3\u003EWhen will my funds be available?\u003C\u002Fh3\u003E\u003Cp\u003EYour bank account will be debited immediately, but BPAY transfers typically take 1-2 Banking Business\nDays to complete.\u003C\u002Fp\u003E\u003Cp\u003EBPAY payments made before your bank’s cut-off time (usually 6pm AEST) on a Banking Business Day will\nbe available in your dashboard the following business day.\u003C\u002Fp\u003E\u003Cp\u003EExample 1: Transfer made at 3pm Tuesday; funds received 11am Wednesday.\u003C\u002Fp\u003E\u003Cp\u003EExample 2: Transfer made at 8pm Friday (after the cut-off); funds received 11am Tuesday.\u003C\u002Fp\u003E\u003Cp\u003EFor more information see the\n\u003Ca href=\"https:\u002F\u002Fwww.bpay.com.au\u002FHelp-Centre\u002FPersonal-User\u002FBPAY-Services-FAQs.aspx\" target=\"_blank\"\u003EBPAY website\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"funds-transferred\" ng-if=\"vm.fundsTransferred()\"\u003E\u003Cp\u003EYour account is now active. You can now browse the \u003Ca ui-sref=\"marketplace\"\u003EP2P Marketplace\u003C\u002Fa\u003E and bid on loans.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fmd-card\u003E";
}
});}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;